import React from "react";
import Login from "./Login";

const Home = () => {
  return (
    <section>
      <Login />
    </section>
  );
};

export default Home;
